// ── Categories ──────────────────────────────────────────────────────────────
export const CATEGORIES = [
  {
    id: 1,
    name: "Electronics",
    icon: "💻",
    colorClass: "blue",
    description: "Gadgets, phones, computers and more",
    count: 0,
  },
  {
    id: 2,
    name: "Fashion",
    icon: "👗",
    colorClass: "pink",
    description: "Clothing, shoes, accessories",
    count: 0,
  },
  {
    id: 3,
    name: "Food",
    icon: "🍔",
    colorClass: "amber",
    description: "Fresh produce, packaged goods, beverages",
    count: 0,
  },
  {
    id: 4,
    name: "Real Estate",
    icon: "🏠",
    colorClass: "green",
    description: "Properties for sale and rent in Lagos",
    count: 0,
  },
  {
    id: 5,
    name: "Home Appliances",
    icon: "🛋️",
    colorClass: "purple",
    description: "Kitchen, furniture, home systems",
    count: 0,
  },
];

// ── Lagos Markets ────────────────────────────────────────────────────────────
export const MARKETS = [
  "Computer Village",
  "Alaba International Market",
  "Balogun Market",
  "Trade Fair Complex",
  "Tejuosho Market",
  "Idumota Market",
  "Mushin Market",
  "Oyingbo Market",
  "Mile 12 Market",
  "Oshodi Market",
  "Agege Market",
  "Lekki Market",
  "Victoria Island Market",
  "Apapa Market",
  "Surulere Shopping Area",
  "Badagry Heritage Market",
  "Owode-Onirin Market",
  "Apongbon Market",
  "Ikotun Market",
  "Maryland Mall",
];

// ── Mock Users ───────────────────────────────────────────────────────────────
// role: "tenant" | "user"
export const MOCK_USERS = [
  {
    id: 1,
    name: "Adewale Johnson",
    email: "adewale@gmail.com",
    password: "password",
    role: "tenant",
    initials: "AJ",
    business: "TechHub Lagos",
    plan: "Premium",
    location: "Victoria Island, Lagos",
    phone: "+234 801 234 5678",
    joinDate: "January 2024",
    bio: "Electronics and tech gadgets dealer based in Victoria Island. Providing quality products since 2020.",
    rating: 4.8,
    totalSales: 2847,
    verified: true,
    hasMarketplaceAccount: true,
  },
  {
    id: 2,
    name: "Chioma Okafor",
    email: "chioma@gmail.com",
    password: "password",
    role: "tenant",
    initials: "CO",
    business: "FashionMart NG",
    plan: "Advanced",
    location: "Lekki Phase 1, Lagos",
    phone: "+234 802 345 6789",
    joinDate: "March 2024",
    bio: "Premium fashion retailer offering latest trends from local and international designers.",
    rating: 4.6,
    totalSales: 1923,
    verified: true,
    hasMarketplaceAccount: false,
  },
  {
    id: 3,
    name: "Emeka Nwosu",
    email: "emeka@gmail.com",
    password: "password",
    role: "user",
    initials: "EN",
    business: "FoodStore Lagos",
    plan: "Free",
    location: "Ikeja, Lagos",
    phone: "+234 803 456 7890",
    joinDate: "June 2024",
    bio: "Fresh organic food products and daily essentials. Serving Ikeja and environs.",
    rating: 4.3,
    totalSales: 456,
    verified: false,
  },
];

// ── Tenant Property Data ─────────────────────────────────────────────────────
// Keyed by user id; only tenant-role users have entries
export const TENANT_PROPERTIES = {
  1: [
    {
      id: "prop-1",
      propertyType: "Warehouse Shop",
      status: "active",
      rentAmount: 100000,
      plan: "Yearly",
      rentStartDate: "2026-03-06",
      rentEndDate: "2027-03-06",
      lastPaymentDate: "2026-03-06",
      transactionRef: "TXN-AJ-2026-0306",
      address: "Block C, Unit 4, Computer Village, Lagos",
    },
    {
      id: "prop-3",
      propertyType: "Retail Storefront",
      status: "due_soon",
      rentAmount: 75000,
      plan: "Quarterly",
      rentStartDate: "2026-01-10",
      rentEndDate: "2026-04-10",
      lastPaymentDate: "2026-01-10",
      transactionRef: "TXN-AJ-2026-0110",
      address: "Shop 5, Victoria Island Mall, Lagos",
    },
  ],
  2: [
    {
      id: "prop-2",
      propertyType: "Warehouse Shop",
      status: "due_soon", // expires within 30 days
      rentAmount: 100000,
      plan: "Yearly",
      rentStartDate: "2025-04-10",
      rentEndDate: "2026-04-10",
      lastPaymentDate: "2025-04-10",
      transactionRef: "TXN-CO-2025-0410",
      address: "Shop 12, Lekki Phase 1 Mall, Lagos",
    },
  ],
};

// ── Products per Tenant ──────────────────────────────────────────────────────
export const INITIAL_PRODUCTS = {
  1: [
    {
      id: 1,
      name: "iPhone 15 Pro Max",
      category: "Electronics",
      price: 850000,
      stock: 12,
      status: "active",
      views: 1423,
      sales: 87,
      featured: true,
      description:
        "Latest Apple flagship smartphone with titanium design and 48MP camera.",
      markets: ["Computer Village", "Victoria Island Market"],
      images: [
        "https://images.unsplash.com/photo-1592286927505-1556f0aa8f43?w=400&h=400&fit=crop",
      ],
    },
    {
      id: 2,
      name: 'Samsung 65" QLED TV',
      category: "Electronics",
      price: 650000,
      stock: 5,
      status: "active",
      views: 892,
      sales: 23,
      featured: true,
      description: "4K Smart TV with quantum dot technology and Tizen OS.",
      markets: ["Computer Village", "Lekki Market"],
      images: [
        "https://images.unsplash.com/photo-1593642632823-8f785ba67e45?w=400&h=400&fit=crop",
      ],
    },
    {
      id: 3,
      name: "MacBook Pro M3",
      category: "Electronics",
      price: 1200000,
      stock: 8,
      status: "active",
      views: 2103,
      sales: 45,
      featured: false,
      description: "Apple MacBook Pro with M3 chip, 16GB RAM, 512GB SSD.",
      markets: ["Computer Village"],
      images: [
        "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=400&h=400&fit=crop",
      ],
    },
    {
      id: 4,
      name: "Sony WH-1000XM5",
      category: "Electronics",
      price: 185000,
      stock: 20,
      status: "active",
      views: 567,
      sales: 34,
      featured: false,
      description:
        "Premium noise-canceling wireless headphones with 30hr battery.",
      markets: ["Victoria Island Market", "Lekki Market"],
      images: [
        "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=400&fit=crop",
      ],
    },
    {
      id: 5,
      name: "Ergonomic Gaming Chair",
      category: "Home Appliances",
      price: 95000,
      stock: 0,
      status: "out_of_stock",
      views: 234,
      sales: 15,
      featured: false,
      description:
        "Ergonomic gaming chair with lumbar support and adjustable armrests.",
      markets: ["Oshodi Market"],
      images: [
        "https://images.unsplash.com/photo-1598046891726-48e76994b5d1?w=400&h=400&fit=crop",
      ],
    },
    {
      id: 6,
      name: 'iPad Pro 12.9"',
      category: "Electronics",
      price: 680000,
      stock: 15,
      status: "active",
      views: 1102,
      sales: 28,
      featured: true,
      description: "Apple iPad Pro with M2 chip and Liquid Retina XDR display.",
      markets: ["Computer Village"],
      images: [
        "https://images.unsplash.com/photo-1527814050087-3793815479db?w=400&h=400&fit=crop",
      ],
    },
  ],
  2: [
    {
      id: 1,
      name: "Ankara Maxi Dress",
      category: "Fashion",
      price: 25000,
      stock: 45,
      status: "active",
      views: 892,
      sales: 123,
      featured: true,
      description:
        "Authentic Ankara print maxi dress, available in multiple sizes S-3XL.",
      markets: ["Balogun Market", "Lekki Market"],
      images: [
        "https://images.unsplash.com/photo-1595777707802-221b77b9e7e1?w=400&h=400&fit=crop",
      ],
    },
    {
      id: 2,
      name: "Italian Leather Handbag",
      category: "Fashion",
      price: 78000,
      stock: 12,
      status: "active",
      views: 1203,
      sales: 67,
      featured: true,
      description: "Genuine Italian leather handbag with gold-plated hardware.",
      markets: ["Victoria Island Market"],
      images: [
        "https://images.unsplash.com/photo-1548036328-c9fa89d128fa?w=400&h=400&fit=crop",
      ],
    },
    {
      id: 3,
      name: "Adire Tie-Dye 2pc Set",
      category: "Fashion",
      price: 35000,
      stock: 30,
      status: "active",
      views: 445,
      sales: 89,
      featured: false,
      description: "Traditional Yoruba Adire fabric 2-piece co-ord set.",
      markets: ["Balogun Market", "Tejuosho Market"],
      images: [
        "https://images.unsplash.com/photo-1608808524-9f54534b129f?w=400&h=400&fit=crop",
      ],
    },
    {
      id: 4,
      name: "Designer Sneakers",
      category: "Fashion",
      price: 55000,
      stock: 8,
      status: "active",
      views: 789,
      sales: 34,
      featured: false,
      description: "Premium designer sneakers, genuine leather upper.",
      markets: ["Lekki Market"],
      images: [
        "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&h=400&fit=crop",
      ],
    },
    {
      id: 5,
      name: "Agbada Senator Set",
      category: "Fashion",
      price: 42000,
      stock: 20,
      status: "active",
      views: 534,
      sales: 56,
      featured: false,
      description: "3-piece Agbada senator outfit for men, various fabrics.",
      markets: ["Balogun Market"],
      images: [
        "https://images.unsplash.com/photo-1591195853828-11db59a44f6b?w=400&h=400&fit=crop",
      ],
    },
  ],
  3: [
    {
      id: 1,
      name: "Organic Tomatoes (5kg)",
      category: "Food",
      price: 3500,
      stock: 200,
      status: "active",
      views: 234,
      sales: 89,
      featured: false,
      description:
        "Fresh organic tomatoes directly from local farms in Ogun State.",
      markets: ["Mile 12 Market", "Mushin Market"],
      images: [
        "https://images.unsplash.com/photo-1585694032915-c3400ca199e7?w=400&h=400&fit=crop",
      ],
    },
    {
      id: 2,
      name: "Whole Grain Bread",
      category: "Food",
      price: 1800,
      stock: 50,
      status: "active",
      views: 123,
      sales: 145,
      featured: false,
      description: "Freshly baked whole grain bread, baked daily.",
      markets: ["Idumota Market"],
      images: [
        "https://images.unsplash.com/photo-1509042239860-f550ce710b93?w=400&h=400&fit=crop",
      ],
    },
    {
      id: 3,
      name: "Pure Red Palm Oil (10L)",
      category: "Food",
      price: 12000,
      stock: 30,
      status: "active",
      views: 345,
      sales: 67,
      featured: false,
      description: "Pure unrefined red palm oil from Edo State farms.",
      markets: ["Oyingbo Market"],
      images: [
        "https://images.unsplash.com/photo-1587788056669-074932191f76?w=400&h=400&fit=crop",
      ],
    },
    {
      id: 4,
      name: "Basmati Rice (10kg)",
      category: "Food",
      price: 8500,
      stock: 0,
      status: "out_of_stock",
      views: 189,
      sales: 34,
      featured: false,
      description: "Premium long-grain basmati rice, aromatic and fluffy.",
      markets: ["Apapa Market"],
      images: [
        "https://images.unsplash.com/photo-1586985289688-cacf913bb194?w=400&h=400&fit=crop",
      ],
    },
  ],
};

// ── Notifications per Tenant ─────────────────────────────────────────────────
export const MOCK_NOTIFICATIONS = {
  1: [
    {
      id: 1,
      type: "order",
      title: "New Order Received",
      message:
        "You have a new order for iPhone 15 Pro Max from Babatunde Adeyemi.",
      time: "2 min ago",
      read: false,
    },
    {
      id: 2,
      type: "review",
      title: "New 5-Star Review",
      message:
        "A customer left an excellent review on your MacBook Pro M3 listing.",
      time: "1 hour ago",
      read: false,
    },
    {
      id: 3,
      type: "system",
      title: "Premium Plan Active",
      message:
        "Your Premium subscription has been renewed. Enjoy unlimited listings!",
      time: "2 hours ago",
      read: true,
    },
    {
      id: 4,
      type: "order",
      title: "Order Delivered",
      message:
        "Order #1234 for Samsung QLED TV has been successfully delivered.",
      time: "1 day ago",
      read: true,
    },
    {
      id: 5,
      type: "promo",
      title: "Featured Listing Expiring",
      message: "Your featured listing for Sony Headphones expires in 2 days.",
      time: "2 days ago",
      read: true,
    },
  ],
  2: [
    {
      id: 1,
      type: "order",
      title: "New Order Received",
      message: "New order for Ankara Maxi Dress (Size L) from Ngozi Williams.",
      time: "5 min ago",
      read: false,
    },
    {
      id: 2,
      type: "system",
      title: "Advanced Plan Benefits",
      message:
        "You now have access to Advanced Analytics. Check your dashboard!",
      time: "3 hours ago",
      read: false,
    },
    {
      id: 3,
      type: "review",
      title: "Customer Review",
      message:
        "A customer left a 4-star review on your Italian Leather Handbag.",
      time: "5 hours ago",
      read: true,
    },
    {
      id: 4,
      type: "promo",
      title: "Boost Your Sales",
      message:
        "Upgrade to Premium for unlimited featured listings and priority placement.",
      time: "1 day ago",
      read: true,
    },
  ],
  3: [
    {
      id: 1,
      type: "system",
      title: "Upgrade Your Plan",
      message:
        "You have reached your 5-product limit. Upgrade to Advanced for 50 listings.",
      time: "1 hour ago",
      read: false,
    },
    {
      id: 2,
      type: "order",
      title: "New Order",
      message: "New order for Organic Tomatoes (5kg) from Afolabi Olatunji.",
      time: "3 hours ago",
      read: true,
    },
    {
      id: 3,
      type: "review",
      title: "New Review",
      message: "Customer reviewed your Pure Red Palm Oil listing.",
      time: "1 day ago",
      read: true,
    },
  ],
};

// ── Subscription Plans ──────────────────────────────────────────────────────
// This matches the API structure from /plan-management/plans endpoint
// Used as fallback when API is unavailable or during development
export const SUBSCRIPTION_PLANS = [
  {
    id: "free-plan",
    name: "Free",
    price: 0,
    isFree: true,
    maxProducts: 5,
    maxCategories: 1,
    markets: [{ id: "comp-village", name: "Computer Village", city: "Lagos" }],
  },
  {
    id: "advanced-plan",
    name: "Advanced",
    price: 15000,
    isFree: false,
    maxProducts: 50,
    maxCategories: 999, // All categories
    markets: [
      { id: "comp-village", name: "Computer Village", city: "Lagos" },
      { id: "balogun", name: "Balogun Market", city: "Lagos" },
      { id: "victoria-island", name: "Victoria Island Market", city: "Lagos" },
      { id: "lekki", name: "Lekki Market", city: "Lagos" },
      { id: "tejuosho", name: "Tejuosho Market", city: "Lagos" },
    ],
  },
  {
    id: "premium-plan",
    name: "Premium",
    price: 35000,
    isFree: false,
    maxProducts: 999999, // Unlimited
    maxCategories: 999, // All categories
    markets: [
      { id: "comp-village", name: "Computer Village", city: "Lagos" },
      { id: "balogun", name: "Balogun Market", city: "Lagos" },
      { id: "victoria-island", name: "Victoria Island Market", city: "Lagos" },
      { id: "lekki", name: "Lekki Market", city: "Lagos" },
      { id: "tejuosho", name: "Tejuosho Market", city: "Lagos" },
      { id: "trade-fair", name: "Trade Fair Complex", city: "Lagos" },
      { id: "idumota", name: "Idumota Market", city: "Lagos" },
      { id: "mushin", name: "Mushin Market", city: "Lagos" },
      { id: "oyingbo", name: "Oyingbo Market", city: "Lagos" },
      { id: "mile-12", name: "Mile 12 Market", city: "Lagos" },
      { id: "oshodi", name: "Oshodi Market", city: "Lagos" },
      { id: "agege", name: "Agege Market", city: "Lagos" },
      { id: "apapa", name: "Apapa Market", city: "Lagos" },
    ],
  },
];

// ── Chart / Analytics Data per Tenant ────────────────────────────────────────
export const ANALYTICS_DATA = {
  1: {
    salesTrend: [42, 58, 63, 71, 88, 95, 87, 102, 115, 98, 124, 131],
    viewsTrend: [320, 480, 520, 610, 780, 830, 790, 920, 1050, 980, 1120, 1300],
    months: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    totalRevenue: 12480000,
    totalViews: 10700,
    totalOrders: 232,
    conversionRate: 3.2,
  },
  2: {
    salesTrend: [28, 35, 42, 51, 63, 72, 68, 80, 91, 76, 95, 102],
    viewsTrend: [210, 290, 340, 420, 510, 580, 550, 640, 720, 690, 780, 890],
    months: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    totalRevenue: 4750000,
    totalViews: 7620,
    totalOrders: 369,
    conversionRate: 4.8,
  },
  3: {
    salesTrend: [8, 12, 15, 18, 20, 24, 22, 28, 31, 26, 34, 38],
    viewsTrend: [80, 110, 130, 160, 180, 210, 195, 230, 265, 240, 290, 320],
    months: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    totalRevenue: 345000,
    totalViews: 2210,
    totalOrders: 335,
    conversionRate: 15.2,
  },
};
